<ol class="steps" *ngIf="listOfProcesses">
  <ng-container *ngFor="let opt of listOfProcesses;let i = index">
    <li (click)="StatusClicked(i)"  class="step {{opt.class}}" data-step="1">
      <p class="labelSteps">{{opt.categorie}}</p>
    </li>
  </ng-container>
</ol>
